/*
 * "Læs mere"-toggle: erstatter en afkortet tekst med den fulde, når man klikker.
 * Markup: [data-read-more] med [data-read-more-short] (afkortet + knap) og
 * [data-read-more-full] (skjult fuld tekst). Knappen har [data-read-more-btn].
 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-read-more-btn]');
  if (!btn) return;
  e.preventDefault();
  var wrap = btn.closest('[data-read-more]');
  if (!wrap) return;
  var short = wrap.querySelector('[data-read-more-short]');
  var full = wrap.querySelector('[data-read-more-full]');
  if (short) short.hidden = true;
  if (full) full.hidden = false;
});
